<template>
  <div>
    <Head title="Create Recording" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/recordings">Recordings</Link>
      <span class="text-indigo-400 font-medium">/</span> Create
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2" label="Name" />
          <select-input v-model="form.stream_id" :error="form.errors.stream_id" class="pb-8 pr-6 w-full lg:w-1/2" label="Stream">
            <option :value="null" />
            <option v-for="stream in streams" :key="stream.id" :value="stream.id">{{ stream.name }}</option>
          </select-input>
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <Link class="text-blue-600 hover:underline mr-2" tabindex="-1" href="/recordings">Go back</Link>
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Create Recording</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from "@/Shared/SelectInput.vue";

export default {
  components: {
    SelectInput,
    Head,
    Link,
    LoadingButton,
    TextInput,
  },
  layout: Layout,
  remember: 'form',
  props: {
    streams: Array,
  },
  data() {
    return {
      form: this.$inertia.form({
        name: null,
        stream_id: null,
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/recordings')
    },
  },
}
</script>
